import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/da'; // Add locale data for da

import '@formatjs/intl-relativetimeformat/polyfill';
import '@formatjs/intl-relativetimeformat/locale-data/da'; // Add locale data for da
import daMessages from '../locales/da_DA.json';

const daLang = {
    messages: { ...daMessages },
    locale: 'da-DA'
};

export default daLang;
